import { combineReducers } from "redux";
import transactions from "./transactions/reducer";
const cpReducer = combineReducers({
  // clients: ibClients,
  transactions,
  // agreements: agreementReducer,
});

export default cpReducer;
